// src/pages/Contact.js
import React from 'react';
import { useTranslation } from 'react-i18next';

const Contact = () => {
    const { t } = useTranslation();

return (
  <section
    style={{ marginTop: '-15px', width: '100%', minHeight: '30rem' }}
    className="relative overflow-hidden bg-[#060826] text-white"
  >
    {/* Left decorative line */}
    <div className="absolute left-6 top-0 hidden h-full w-px bg-white/10 sm:left-10 lg:block xl:left-20" />

    <div className="relative z-10 flex flex-col px-6 py-10 sm:px-10 sm:py-14 lg:px-20 lg:py-16">
      
      {/* Content */}
      <div className="max-w-5xl">
        <h1 className="text-6xl font-extrabold leading-none tracking-tight text-[#ff6a00] sm:text-7xl md:text-8xl lg:text-[120px]">
          {t('contact.hero.logo')}
        </h1>

        <h2 className="mt-4 max-w-4xl text-3xl font-bold leading-tight sm:mt-5 sm:text-4xl md:text-5xl lg:text-6xl">
          {t('contact.hero.heading')}
        </h2>

        <div className="mt-8 flex items-start gap-4 sm:mt-10 sm:gap-6">
          <div className="mt-1 h-6 w-[3px] shrink-0 bg-[#ff6a00] sm:h-8" />

          <p className="max-w-2xl text-lg font-light leading-relaxed text-white/80 sm:text-xl md:text-2xl lg:text-3xl">
            {t('contact.hero.description')}
          </p>
        </div>
      </div>

      {/* Spacer instead of flex-1 */}
      <div className="h-10 sm:h-14 lg:h-20" />

      {/* Footer */}
      <div className="
        flex
        flex-col
        gap-6
        md:flex-row
        md:items-end
        md:justify-between
      ">
        {/* Contacts */}
        <div className="
          flex
          flex-col
          gap-4
          text-xs
          uppercase
          tracking-[0.2em]
          text-white/60
          sm:text-sm
          md:flex-row
          md:items-center
          md:gap-8
        ">
          <div className="flex items-center gap-3">
            <span className="text-[#ff6a00]">✉</span>
            <a href="mailto:info@dvakota.com" className="break-all text-inherit no-underline">
              info@dvakota.com
            </a>
          </div>

          <div className="flex items-center gap-3">
            <span className="text-[#ff6a00]">◉</span>
            <span className="break-all">www.dvakota.com</span>
          </div>
        </div>

        {/* Decorative square */}
        <div className="h-14 w-14 border border-[#ff6a00] sm:h-18 sm:w-18 lg:h-22 lg:w-22" />
      </div>

    </div>
  </section>
);
};

export default Contact;